import "./notification.css";

const Notification = () => {
  return (
    <div className="wa_notification">
      <i className="fa-solid fa-bell"></i>
      <span className="wa_notificationBadge"></span>
    </div>
  );
};

export default Notification;
